import { Controller } from "@hotwired/stimulus";

// Connects to data-controller='categories--admin--review-gifts--recurring-gift-radio'
//
// Keeps the "Enter in Existing Recurring Gift ID" input required only while that option is
// actually selected, and only when a choice is required at all. While the record has other
// errors the choice is optional, so the admin can submit fixes for those without picking one.
//
// This has to stay scoped to its own panel. The review page renders one modal per gift, so a
// document-wide lookup makes every gift on the page follow the *first* gift's radio state —
// which left "Create new Recurring Gift in RE NXT" unsubmittable on every row but the first.
export default class extends Controller {
  static targets = ["existingRadio", "externalIdentifier"];

  static values = { choiceRequired: Boolean };

  connect() {
    this.updateRequired();
  }

  updateRequired() {
    this.existingRadioTarget.required = this.choiceRequiredValue;
    this.externalIdentifierTarget.required = this.choiceRequiredValue && this.existingRadioTarget.checked;
  }
}
